<app-global-breadcrumbs class="d-none"></app-global-breadcrumbs>
<app-global-inner-banner>User Management</app-global-inner-banner>
<div class="management-main">
    <section class="section-gap innerpage pageStaticsBgColor">
        <div class="container">
            <mat-card class="wrapperStaticsCotent">
                <div class="mainHeader titleSection d-flex">
                    <h3>{{userManagement.value.type === 'editUser' ? 'Update User' : 'Create User'}}</h3>
                    <div class="spacer"></div>
                    <button mat-button color="primary" (click)="showUserDiv = true"><mat-icon color="primary">person_add</mat-icon>&nbsp;&nbsp;Create User</button>
                </div>
                <ng-container *ngIf="showUserDiv">
                    <div class="createUserWrapper">
                        <div class="wrapperCreateUser">
                            <form [formGroup]="userManagement">
                                <div class="row">
                                    <mat-form-field appearance="outline" floatLabel="always" class="col-md-4">
                                        <mat-label>Enter your First Name</mat-label>
                                        <input matInput placeholder="Enter your First Name" [formControl]="firstName" maxlength="48" restrictTo valType="charOnly">
                                        <mat-error *ngIf="firstName.hasError('required')"><strong>First Name</strong> is required.</mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" class="col-md-4">
                                        <mat-label>Enter your Last Name</mat-label>
                                        <input matInput placeholder="Enter your Last Name" [formControl]="lastName" maxlength="48" restrictTo valType="charOnly">
                                        <mat-error *ngIf="lastName.hasError('required')"><strong>Last Name</strong> is required.</mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" class="col-md-4">
                                        <mat-label>Enter your Email Address</mat-label>
                                        <input matInput placeholder="Enter your Email Address" [formControl]="emailAddress" appDisableCopyPaste appLowercaseInput>
                                        <mat-error *ngIf="emailAddress.hasError('required')"><strong>Email Address</strong> is required.</mat-error>
                                        <mat-error *ngIf="emailAddress.hasError('pattern')">Enter a valid <strong>Email Address</strong>.</mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" class="col-md-2">
                                        <mat-label>Select your Country</mat-label>
                                        <mat-select placeholder="Select your Country" [formControl]="countryCode">
                                            <mat-option *ngFor="let item of countryList" [value]="item.phonecode">{{item.name}} ({{item.phonecode}})</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="countryCode.hasError('required')">Country field is required.</mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" class="col-md-5">
                                        <mat-label>Enter your Mobile Number</mat-label>
                                        <input matInput placeholder="Enter your Mobile Number" [formControl]="mobile" restrictTo valType="numberOnly" minlength="4" maxlength="18">
                                        <mat-error *ngIf="mobile.hasError('required')"><strong>Mobile Number</strong> is required.</mat-error>
                                        <mat-error *ngIf="mobile.hasError('pattern')">Enter a valid <strong>Mobile Number</strong>.</mat-error>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" floatLabel="always" class="col-md-5">
                                        <mat-label>Select your User Type</mat-label>
                                        <mat-select placeholder="Select your User Type" [formControl]="userType">
                                            <mat-option *ngFor="let item of userB2BType" [value]="item.key">{{item.value}}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="userType.hasError('required')">User Type field is required.</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 pt-3">
                                    <button mat-button color="primary" class="primaryButton" (click)="submit_management()">{{userManagement.value.type === 'editUser' ? 'Update' : 'Submit'}}</button>&nbsp;&nbsp;
                                    <button mat-button color="warn" class="warnButton" (click)="reset_management()">Reset</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-container>
            </mat-card>
            <ng-container>
                <mat-card class="wrapperStaticsCotent">
                    <div class="mainHeader titleSection d-flex">
                        <h3>Management User List</h3>
                        <div class="spacer"></div>
                    </div>
                    <div class="createUserWrapper">
                        <div class="wrapperCreateUser">
                            <app-mat-table  [columns]="columns" [dataSource]="listItem" (rowAction)="rowAction($event)"></app-mat-table>
                        </div>
                    </div>
                </mat-card>
            </ng-container>
        </div>
    </section>
</div>